import { styled, TableRow } from "@mui/material"

export const StyledTableRow = styled(TableRow)((props) => {
    const { sx } = props;
  
    return {
      '&': {
        cursor: sx?.cursor ?? 'pointer'
      },
      '& > th': {
        // borderRight: '1px solid #f1f3f4 !important',
        // backgroundColor: '#f1f3f4'
      },
      // '&:last-child > *': {
        // borderRight: 'unset',
      // },
      '& > td': {
        fontSize: '12px'
      },
      '& > td:last-child': {
        whiteSpace: 'nowrap'
      }
    }
})